<script setup>
import OutlinedButton from '@/Components/Button/OutlinedButton.vue';
import { usePage } from '@inertiajs/vue3';
import { captureContactClicked } from '@/Common/Posthog.js';

const { branding } = usePage().props;

const redirect = () => {
  captureContactClicked();
  window.open(
    branding.contact.href ?? 'https://sendmarc.com/contact/',
    '_blank'
  );
};
</script>

<template>
  <OutlinedButton v-if="branding?.contact?.href" size="large" @click="redirect">
    {{ branding.contact.title }}
  </OutlinedButton>
</template>
